import { render, staticRenderFns } from "./GenusCard.vue?vue&type=template&id=c50a4840"
import script from "./GenusCard.vue?vue&type=script&lang=js"
export * from "./GenusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports